import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  CircularProgress,
  TextField,
  IconButton,
  InputAdornment,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Collapse,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";


const ViewPatient = () => {

const [editOpen, setEditOpen] = useState(false);
const [editPatient, setEditPatient] = useState(null);



  const [patients, setPatients] = useState([]);
  const [searchId, setSearchId] = useState("");
  const [filteredPatient, setFilteredPatient] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openRow, setOpenRow] = useState(null);
const [selectedPatient, setSelectedPatient] = useState(null);
const [dialogOpen, setDialogOpen] = useState(false);


    const BASE_URL = process.env.REACT_APP_BASE_URL;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

 const fetchPatients = async () => {
  try {
    const token = localStorage.getItem("jwt");

    const res = await axios.get(
      `${BASE_URL}/api/receptionist/patients`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    setPatients(res.data.patients || []);

  } catch (err) {
    toast.error("Failed to fetch patients");
  }
};

useEffect(() => {
  fetchPatients();
}, []);
 
  // useEffect(() => {
  //   const fetchPatients = async () => {
  //     try {
  //       const token = localStorage.getItem("jwt");
  //       const res = await axios.get(
  //         `${BASE_URL}/api/receptionist/patients`,
  //         { headers: { Authorization: `Bearer ${token}` } }
  //       );
  //       // const activePatients = res.data.patients?.filter(
  //       //   (p) => p.status.toLowerCase() !== "discharged"
  //       // );
  //      setPatients(res.data.patients || []); 
  //     } catch (err) {
  //       toast.error("Failed to fetch patients");
  //     }
  //   };

  //   fetchPatients();
  // }, []);
//   const normalizeDate = (dob) => {
//   if (!dob) return null;
//   const parts = dob.split("/").map(Number);
//   if (parts.length !== 3) return null;
//   const [day, month, year] = parts;
//   return `${year.toString().padStart(4,"0")}-${month.toString().padStart(2,"0")}-${day.toString().padStart(2,"0")}`;
// };
const handleSearch = () => {
  const search = searchId.trim();
  if (!search) {
    setFilteredPatient(null);
    return;
  }

  const found = patients.filter((p) => {
    // Match by Patient ID or Name
    if (p.patientId?.toLowerCase() === search.toLowerCase()) return true;
    if (p.fullName?.toLowerCase().includes(search.toLowerCase())) return true;

    // Match by Aadhaar (ignore spaces)
    if (p.aadhaarNumber?.replace(/\s/g, '').includes(search.replace(/\s/g, ''))) return true;

  

    return false;
  });

  if (found.length > 0) {
    setFilteredPatient(found); // always an array
  } else {
    setFilteredPatient([]);
    toast.error("No patient found");
  }
}

const handleEdit = (patient) => {
  setEditPatient({
    ...patient,
    dob: patient.dob
      ? patient.dob.split("T")[0]
      : ""
  });

  setEditOpen(true);
};


const handleUpdatePatient = async () => {
  try {

    const token = localStorage.getItem("jwt");

    await axios.put(
      `${BASE_URL}/api/receptionist/patient/${editPatient._id}`,
      editPatient,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    toast.success("Patient updated");

    setEditOpen(false);

    fetchPatients();

  } catch (err) {

    console.log(err);

    toast.error("Update failed");
  }
};

const handleDeletePatient = async (id) => {

  const confirmDelete =
    window.confirm(
      "Are you sure you want to delete?"
    );

  if (!confirmDelete) return;

  try {

    const token = localStorage.getItem("jwt");

    await axios.delete(
      `${BASE_URL}/api/receptionist/patient/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    toast.success("Patient deleted");

    fetchPatients();

  } catch (err) {

    console.log(err);

    toast.error("Delete failed");
  }
};


  const renderTableRow = (p, index) => (
    <React.Fragment key={p.patientId} >
      <TableRow hover sx={{ p: 1, border: 1 }}>
          <TableCell>{index + 1}</TableCell>
        <TableCell >{p.patientId}</TableCell>
        <TableCell>{p.fullName}</TableCell>
        {!isMobile && <TableCell >{new Date(p.dob).toLocaleDateString()}</TableCell>}
        {!isMobile && <TableCell >{p.gender}</TableCell>}
        {!isMobile && <TableCell >{p.contactNumber}</TableCell>}
 <TableCell>
  {p.status === "Discharged"
    ? "Discharged"
    : "Active"}
</TableCell>
        <TableCell >
        {/* <IconButton onClick={() => {
  setSelectedPatient(p);
  setDialogOpen(true);
}}>
   <EditIcon />
  </IconButton> */}
  {/* <IconButton
  color="primary"
  onClick={() => handleEdit(p)}
>
  <EditIcon />
</IconButton> */}



<TableCell>
  {/* More Details */}
  <IconButton
    color="info"
    onClick={() => {
      setSelectedPatient(p);
      setDialogOpen(true);
    }}
  >
    <ExpandMoreIcon />
  </IconButton>

  {/* Edit */}
  <IconButton
    color="primary"
    onClick={() => handleEdit(p)}
  >
    <EditIcon />
  </IconButton>

  {/* Delete */}
  <IconButton
    color="error"
    onClick={() =>
      handleDeletePatient(p._id)
    }
  >
    <DeleteIcon />
  </IconButton>
</TableCell>


{/* <TableCell> */}

  {/* More Details */}
  {/* <IconButton
    color="info"
    onClick={() => {
      setSelectedPatient(p);
      setDialogOpen(true);
    }}
  >
    <ExpandMoreIcon />
  </IconButton> */}

  {/* Edit */}
  {/* <IconButton
    color="primary"
    onClick={() => handleEdit(p)}
  >
    <EditIcon />
  </IconButton> */}

  {/* Delete */}
  {/* <IconButton
    color="error"
    onClick={() =>
      handleDeletePatient(p._id)
    }
  >
    <DeleteIcon />
  </IconButton>

</TableCell> */}


  {/* <IconButton
    color="error"
    onClick={() =>
      handleDeletePatient(p._id)
    }
  >
    <DeleteIcon />
  <ExpandMoreIcon />
</IconButton> */}

        </TableCell>
      </TableRow>
      <TableRow sx={{ p: 1, border: 1 }}>
        <TableCell colSpan={isMobile ? 5 : 8} sx={{ p: 0, border: 1 }}>
          <Collapse in={openRow === index} timeout="auto" unmountOnExit>
            <Box sx={{ p: 1, bgcolor: "black" , border: 1 }}>
              <Typography><strong>Email:</strong> {p.email}</Typography>
              <Typography><strong>Address:</strong> {p.address}</Typography>
              <Typography mt={1}><strong>Relatives:</strong></Typography>
              {p.relatives?.length ? (
                <ul>
                  {p.relatives.map((r, i) => (
                    <li key={i}>
                      {r.name} ({r.relationship}) - {r.contactNumber}
                    </li>
                  ))}
                </ul>
              ) : (
                <Typography>No relatives listed.</Typography>
              )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );

const rowsToRender = filteredPatient && filteredPatient.length > 0 ? filteredPatient : [...patients].reverse();



  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Patient Records
      </Typography>

      <TextField
        label="Search by Patient ID, Name or Aadhaar"
        variant="outlined"
        fullWidth
        value={searchId}
        onChange={(e) => setSearchId(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && handleSearch()}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleSearch}>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{ mb: 3 }}
      />

      {loading ? (
        <Box display="flex" justifyContent="center" my={5}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper} >
          <Table size={isMobile ? "small" : "medium" }>
          <TableHead>
  <TableRow sx={{ p: 0, border: 1 }}>
    <TableCell>Sr. No.</TableCell>
    <TableCell>Patient ID</TableCell>
    
    <TableCell>Name</TableCell>
    {!isMobile && <TableCell>DOB</TableCell>}
    {!isMobile && <TableCell>Gender</TableCell>}
    {!isMobile && <TableCell>Contact</TableCell>}
    <TableCell>Status</TableCell>
    <TableCell>More</TableCell>
  {/* <TableCell>More</TableCell>
<TableCell>Action</TableCell> */}
  </TableRow>
</TableHead>

            <TableBody>
              {rowsToRender.map((p, i) => renderTableRow(p, i))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <ToastContainer position="top-right" autoClose={3000} />
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} fullWidth maxWidth="sm">
  <DialogTitle>Patient Details</DialogTitle>
  <DialogContent dividers>
    {selectedPatient && (
      <>
        <Typography><strong>Full Name:</strong> {selectedPatient.fullName}</Typography>
        <Typography><strong>DOB:</strong> {new Date(selectedPatient.dob).toLocaleDateString()}</Typography>
        <Typography><strong>Gender:</strong> {selectedPatient.gender}</Typography>
        <Typography><strong>Email:</strong> {selectedPatient.email}</Typography>
        <Typography><strong>Contact Number:</strong> {selectedPatient.contactNumber}</Typography>
       <Typography><strong>Aadhaar Number:</strong> {selectedPatient.aadhaarNumber}</Typography>

        <Typography><strong>Address:</strong> {selectedPatient.address}</Typography>
 <Typography mt={2}>
  <strong>Visit History:</strong>
</Typography>

{selectedPatient.visits?.length > 0 ? (

  selectedPatient.visits.map((visit, index) => (

    <Box
      key={visit._id}
      sx={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "10px",
        marginTop: "10px"
      }}
    >

      <Typography>
        <strong>Visit #{index + 1}</strong>
      </Typography>

      <Typography>
        <strong>Visit Type:</strong>{" "}
        {visit.visitType}
      </Typography>

      <Typography>
        <strong>Doctor:</strong>{" "}
        {visit.assignedDoctorId?.userId?.name || "N/A"}
      </Typography>

      <Typography>
        <strong>Billing Type:</strong>{" "}
        {visit.billingType}
      </Typography>

      <Typography>
        <strong>Payment:</strong>{" "}
        ₹ {visit.payment?.amount || 0}
      </Typography>

      <Typography>
        <strong>Payment Status:</strong>{" "}
        {visit.payment?.isPaid
          ? "Paid"
          : "Pending"}
      </Typography>

      <Typography>
        <strong>Status:</strong>{" "}
        {visit.status}
      </Typography>

      <Typography>
        <strong>Visit Date:</strong>{" "}
        {new Date(visit.createdAt).toLocaleString()}
      </Typography>

    </Box>

  ))

) : (
  <Typography>No visit found</Typography>
)}
        <Typography mt={2}><strong>Relatives:</strong></Typography>
        {selectedPatient.relatives?.length ? (
          <ul>
            {selectedPatient.relatives.map((r, i) => (
              <li key={i}>
                {r.name} ({r.relationship}) - {r.contactNumber}
              </li>
            ))}
          </ul>
        ) : (
          <Typography>No relatives listed.</Typography>
        )}
      </>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setDialogOpen(false)} color="primary">
      Close
    </Button>
  </DialogActions>
</Dialog>

<Dialog
  open={editOpen}
  onClose={() => setEditOpen(false)}
  fullWidth
  maxWidth="sm"
>

  <DialogTitle>
    Edit Patient
  </DialogTitle>

  <DialogContent>

    {editPatient && (

      <Box
        display="flex"
        flexDirection="column"
        gap={2}
        mt={1}
      >

        <TextField
          label="Full Name"
          value={editPatient.fullName}
          onChange={(e) =>
            setEditPatient({
              ...editPatient,
              fullName: e.target.value
            })
          }
        />

        <TextField
          type="date"
          label="DOB"
          InputLabelProps={{
            shrink: true
          }}
          value={editPatient.dob}
          onChange={(e) =>
            setEditPatient({
              ...editPatient,
              dob: e.target.value
            })
          }
        />

        <TextField
          label="Gender"
          value={editPatient.gender}
          onChange={(e) =>
            setEditPatient({
              ...editPatient,
              gender: e.target.value
            })
          }
        />

        <TextField
          label="Contact"
          value={editPatient.contactNumber}
          onChange={(e) =>
            setEditPatient({
              ...editPatient,
              contactNumber:
                e.target.value
            })
          }
        />

        <TextField
          label="Email"
          value={editPatient.email}
          onChange={(e) =>
            setEditPatient({
              ...editPatient,
              email: e.target.value
            })
          }
        />

        <TextField
          label="Address"
          multiline
          rows={3}
          value={editPatient.address}
          onChange={(e) =>
            setEditPatient({
              ...editPatient,
              address: e.target.value
            })
          }
        />

      </Box>

    )}

  </DialogContent>

  <DialogActions>

    <Button
      onClick={() =>
        setEditOpen(false)
      }
    >
      Cancel
    </Button>

    <Button
      variant="contained"
      onClick={handleUpdatePatient}
    >
      Update
    </Button>

  </DialogActions>

</Dialog>

    </Container>
  );
};

export default ViewPatient;
